import httpRequest from "../network/http";


//获取城市地图信息
export function getAreaMapJson(option) {
  return httpRequest({
    url: '/sys/screen/getAreaMapJson?code=' + option,
    method: 'post'
  })
}

//获取城市地图信息
export function getAreaByName(option) {
  return httpRequest({
    url: '/sys/screen/getAreaByName',
    method: 'post',
    data: option
  })
}

//获取城市地图信息
export function getStoreRanking(option) {
  return httpRequest({
    url: '/sys/screen/getStoreRanking',
    method: 'post',
    data: option
  })
}

//现金交易实时
export function moneyTradeRealTime(option) {
  return httpRequest({
    url: '/sys/screen/moneyTradeRealTime',
    method: 'post',
    data: option
  })
}

//积分交易实时
export function scoreTradeRealTime(option) {
  return httpRequest({
    url: '/sys/screen/scoreTradeRealTime',
    method: 'post',
    data: option
  })
}

//直播带货排行
export function liveProductRanking(option) {
  return httpRequest({
    url: '/sys/screen/liveProductRanking',
    method: 'post',
    data: option
  })
}

//直播打赏排行
export function liveGiftRanking(option) {
  return httpRequest({
    url: '/sys/screen/liveGiftRanking',
    method: 'post',
    data: option
  })
}

//城市店铺数据
export function cityTotalInfo(option) {
  return httpRequest({
    url: '/sys/screen/cityTotalInfo',
    method: 'post',
    data: option
  })
}

//城市交易排行
export function cityTradeRanking(option) {
  return httpRequest({
    url: '/sys/screen/cityTradeRanking',
    method: 'post',
    data: option
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js